/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/utils',
        'assets/js/modules/browser',
        'assets/js/modules/popup/PopupLight',
        'assets/js/modules/View',
        'assets/js/modules/widgets/mailingLists/mailingListItemCollection',
        'assets/js/modules/widgets/mailingLists/view/mailingListItemsTableView',
        'assets/js/modules/widgets/mailingLists/view/mailingListUploadTableView',
        'assets/js/modules/widgets/mailingLists/view/mailingListNameView',
        'assets/js/modules/widgets/mailingLists/view/mailingListDeleteView',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min'
    ],
    function(
        $,
        _,
        utils,
        browser,
        { default: Popup },
        View,
        MailingListItemCollection,
        MailingListItemsTableView,
        MailingListUploadTableView,
        MailingListNameView,
        MailingListDeleteView
    ) {
        return View.extend({
            optionTpl: _.template('<option value="<%= cid %>" <% if (isSelected === true) { %> selected <% } %>><%= listName %></option>'),

            events: {
                'click .current-resident-info': 'showCurrentResidentInfo'
            },

            initialize: function(options) {
                this.options = options;
                var _this = this;
                var notSupportedMSToolMessage =
                    'Be aware that your browser might be incompatible with our Mailing Services tool. We recommend you to use a different browser or a newer version of the current one.';
                this.$toolbar = this.$el.find('#mailing-lists-tools');
                this.$add = this.$toolbar.find('.add');
                this.$remove = this.$toolbar.find('.remove');
                this.$undo = this.$toolbar.find('.undo');
                this.$redo = this.$toolbar.find('.redo');
                this.$save = this.$toolbar.find('.save');
                this.$lists = this.$toolbar.find('#my-mailing-lists');
                this.$create = this.$toolbar.find('.create');
                this.$upload = this.$toolbar.find('.upload');
                this.$listFile = this.$toolbar.find('#mailing-list-upload-file');
                this.$addCurrentResident = this.$toolbar.find('#add-current-resident-input');
                this.$records = this.$toolbar.find('.mailing-lists-records');
                this.$records.on('click', function() {
                    _this.updateUndoRedoButtons();
                });
                this.$deleteList = this.$toolbar.find('.delete-list');

                if (!browser.supportWebWorkers() || !browser.supportFileApi()) {
                    this.showFlashMessage(notSupportedMSToolMessage, 'danger', this.$el);
                }

                var mailingListUploadTableView = new MailingListUploadTableView({
                    model: this.model,
                    el: '#mailing-list-column-matcher-popup',
                    table: '#mailing-list-upload-table'
                });

                this.listNameView = new MailingListNameView({
                    model: this.model,
                    el: '#mailing-list-name-popup'
                });

                this.deleteListView = new MailingListDeleteView({
                    model: this.model,
                    el: '#delete-mailing-list-popup'
                });

                this.currentResidentPopup = new Popup($('#mailing-list-current-resident-popup'), {
                    width: 430
                });

                this.listenTo(this.model, {
                    'lists:loaded': this.renderLists,
                    'list:currentRecords:changed': this.updateRecords,
                    'list:nameCreate': this.showListNameInput,
                    'list:reload': this.onListReload,
                    'list:upload': this.clearListFile,
                    'list:uploadPrepared': this.openFileWindow,
                    'list:confirmDelete': this.deleteListConfirm,
                    'items:loaded': this.initTable,
                    'currentList:rollBack': this.updateCurrentList,
                    'undoredo:refresh': this.updateUndoRedoButtons
                });

                this.listenTo(this.listNameView, {
                    submit: function(name) {
                        _this.model.trigger('list:nameCreated', name);
                    }
                });

                this.listenTo(this.deleteListView, {
                    delete: function() {
                        _this.model.trigger('list:remove', _this.$lists.val());
                    }
                });

                this.$add.on('click', function() {
                    _this.model.trigger('item:addPrepare');
                });

                this.$remove.on('click', function() {
                    let itemModels = _this.model
                        .get('currentList')
                        .get('itemsCollection')
                        .where({ selected: true });
                    _this.model.trigger('items:remove', new MailingListItemCollection(itemModels));
                });

                this.$undo.on('click', function() {
                    _this.tableView.undo();
                    _this.updateUndoRedoButtons();
                });

                this.$redo.on('click', function() {
                    _this.tableView.redo();
                    _this.updateUndoRedoButtons();
                });

                this.$save.on('click', function() {
                    _this.model.trigger('list:save');
                });

                this.$create.on('click', function() {
                    _this.model.trigger('list:create');
                });

                this.$upload.on('click', function() {
                    _this.model.trigger('list:uploadPrepare');
                });

                this.$listFile.on('change', function() {
                    if (browser.supportFile()) {
                        _this.onListSubmit(this.files[0]);
                    }
                });

                this.$addCurrentResident.on('click', function() {
                    _this.model.trigger('list:addCurrentResident', $(this).is(':checked'));
                });

                this.$lists.selectBoxIt({ autoWidth: false });
                this.$deleteList.on('click', function(e) {
                    e.stopPropagation();
                    _this.model.trigger('list:confirmDelete');
                });

                this.$toolbar.on('change', '#my-mailing-lists', function() {
                    _this.model.trigger('list:choose', _this.$lists.val());
                });
            },

            initTable: function() {
                if (this.tableView) {
                    return this.renderItems();
                }

                this.tableView = new MailingListItemsTableView({
                    model: this.model,
                    data: this.model
                        .get('currentList')
                        .get('itemsCollection')
                        .getItems(),
                    el: this.$el.find('.mailing-list-items-table-container'),
                    table: '#mailing-list-items-table',
                    height: this.options.height
                });

                this.listenTo(this.tableView, {
                    'table:change': this.onTableChange,
                    'table:scroll': this.onTableScroll,
                    'table:rowCreated': this.updateUndoRedoButtons,
                    'table:undo': this.updateUndoRedoButtons,
                    'table:redo': this.updateUndoRedoButtons
                });

                this.listenTo(this.model, {
                    'lists:added': this.addList,
                    'items:beforeRemove': this.beforeRemoveItems,
                    'change:currentList': this.onCurrentListChange,
                    'items:reload': this.reloadItems,
                    'list:addCurrentResident:changed': this.onCurrentResidentChange,
                    'change:listLoading': this.toggleButtons,
                    'item:addPrepared': this.addRow,
                    'items:restored': this.onItemsRestore,
                    'items:selected': () => {
                        this.updateRemoveRowButton();
                        this.renderItems();
                    },
                    'item:selected': () => {
                        this.updateRemoveRowButton();
                        this.renderItems();
                    },
                    'change:allItemsSelected': this.renderItems,
                    'items:removed': this.onItemsRemove
                });

                this.toggleButtons();
                this.renderItems();
            },

            renderItems: function() {
                this.tableView.render();
            },

            updateRemoveRowButton: function() {
                let itemModels = this.model
                    .get('currentList')
                    .get('itemsCollection')
                    .where({ selected: true });

                this.$remove.prop('disabled', itemModels.length === 0);
            },

            updateDeleteListButton: function() {
                let token = this.model.get('currentList').get('token');
                if (token === null) {
                    this.$deleteList.prop('disabled', true);
                } else {
                    this.$deleteList.prop('disabled', false);
                }
            },

            renderLists: function() {
                var _this = this;
                var currentList = this.model.get('currentList');

                var options = '';
                this.model.get('lists').each(function(list) {
                    options += _this.getOptionTag(list, list.cid === currentList.cid);
                });
                this.$lists.html(options);
                this.updateAddCurrentResident();
                this.$lists.selectBoxIt('refresh');
            },

            addList: function() {
                this.renderLists();

                this.tableView.scrollToFirstCell();
            },

            /**
             * @param {MailingListModel} list
             * @param {boolean} isSelected
             * @return {string}
             */
            getOptionTag: function(list, isSelected) {
                return this.optionTpl({
                    cid: list.cid,
                    listName: list.get('name'),
                    isSelected: isSelected
                });
            },

            updateCurrentList: function() {
                var cid = this.model.get('currentList').cid;
                this.$lists.val(cid);
                this.$lists.selectBoxIt('refresh');
            },

            updateRecords: function() {
                this.$records.html(this.model.get('currentList').get('currentRecords'));
            },

            updateList: function() {
                var list = this.model.get('currentList');
                var $list = this.$lists.find('[value=' + list.cid + ']');

                $list.replaceWith(this.getOptionTag(list, true));
                this.$lists.selectBoxIt('refresh');
            },

            updateAddCurrentResident: function() {
                this.$addCurrentResident.prop('checked', this.model.get('currentList').get('addCurrentResident'));
            },

            beforeRemoveItems: function(items, indexes) {
                this.tableView.logRemoveRowsAction(items, indexes);
            },

            reloadItems: function() {
                this.tableView.loadData(
                    this.model
                        .get('currentList')
                        .get('itemsCollection')
                        .getItems()
                );
                this.updateUndoRedoButtons();
                this.updateDeleteListButton();
            },

            addRow: function() {
                this.tableView.addRow();
            },

            clearListFile: function() {
                this.$listFile.val('');
            },

            showListNameInput: function() {
                this.listNameView.show();
            },

            deleteListConfirm: function() {
                this.deleteListView.show();
                this.model.set('unSavedChanges', false);
            },

            openFileWindow: function() {
                this.$listFile.trigger('click');
            },

            updateUndoRedoButtons: function() {
                this.updateSaveButton();
                this.$redo.prop('disabled', !this.tableView.isRedoAvailable());
                this.$undo.prop('disabled', !this.tableView.isUndoAvailable());

                if (this.tableView.isUndoAvailable()) {
                    this.model.trigger('undo:enabled');
                } else {
                    this.model.trigger('undo:disabled');
                }

                if (this.tableView.isRedoAvailable()) {
                    this.model.trigger('redo:enabled');
                } else {
                    this.model.trigger('redo:disabled');
                }
            },
            updateSaveButton: function() {
                this.$save.prop('disabled', !this.model.get('currentList').get('currentRecords'));
            },

            toggleButtons: function() {
                if (this.model.get('listLoading')) {
                    this.$toolbar.addClass('disabled');
                    this.$toolbar.find('button, input').prop('disabled', true);
                    this.$lists.selectBoxIt('disable');
                } else {
                    this.$toolbar.removeClass('disabled');
                    this.$toolbar.find('button, input').prop('disabled', false);
                    this.$lists.selectBoxIt('enable');
                    this.updateUndoRedoButtons();
                    this.$remove.prop('disabled', true);
                    this.updateDeleteListButton();
                }
            },

            showCurrentResidentInfo: function() {
                this.currentResidentPopup.open();
            },

            onListSubmit: function(listFile) {
                this.model.trigger('list:upload', listFile);
            },

            onItemsRemove: function() {
                this.renderItems();
                this.updateRemoveRowButton();
                this.updateUndoRedoButtons();
            },

            onItemsRestore: function() {
                this.renderItems();
                this.updateUndoRedoButtons();
            },

            onTableChange: function(items, wereEmpty) {
                this.model.trigger('items:change', items, wereEmpty);
                this.updateUndoRedoButtons();
            },

            onTableScroll: function(fromItem, count) {
                var list = this.model.get('currentList');
                if (!list.get('token')) {
                    return;
                }
                var total = list.get('records');
                var fromOrderId = fromItem['orderId'];
                var toOrderId = fromOrderId + count;
                if (toOrderId > total) {
                    toOrderId = total;
                }
                var toItem = list.get('itemsCollection').get(toOrderId);

                if ((fromOrderId <= total && !fromItem['record']) || (toOrderId <= total && toItem !== undefined && !toItem['record'])) {
                    this.model.trigger('items:load', fromOrderId, toOrderId);
                }
            },

            onListReload: function() {
                this.updateList();
                this.updateAddCurrentResident();
                this.updateRecords();
            },

            onCurrentListChange: function() {
                this.updateCurrentList();
                this.updateAddCurrentResident();
                this.updateRecords();
                this.reloadItems();
            },

            onCurrentResidentChange: function() {
                this.renderItems();
            }
        });
    }
);
